import React, { Component, Fragment } from "react";
import { Link, withRouter,Redirect } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-responsive-modal';
import api from "../../../services/api"



class Map extends Component {
  
    state = {
        open: false,
        idfatura:"",
        error:"",
        toreload:false,
        valorinteiro:"",
        valordesconto:"",
        valorpago:"",
        diavencimento:"",
        status:"1",
        transaction_id:"",
        idmatricula:"",
        tentativa:0,
        formapag:"0"

      };
     
      onOpenModal = () => {
        this.setState({ open: true });
      };
     
      onCloseModal = () => {
        this.setState({ open: false,error:"" });

        
       
      };

      componentWillReceiveProps(nextProps){

        if(nextProps.truetoadd!==""){
          if(nextProps.truetoadd){
            this.setState({ open: true,
            idmatricula: nextProps.truetoadd});
          }
        }
        

      }
       
   
      

      addfatura = async e => {
        e.preventDefault();
        
        
        const { formapag,valordesconto, idmatricula, valorinteiro, status, diavencimento } = this.state;
       
          if (!valorinteiro 
              || !diavencimento || !idmatricula) {
              this.setState({ error: "Preencha os dados antes de adicionar!",
            success:null });
              
          }
          else if(this.state.formapag==0 && this.state.status==2){
            this.setState({ error: "Você não pode adicionar fatura paga com boleto. Contate o administrador",
            success:null });
          } 
          else {

          const response = await api.post("/admin/fatura/add", {
            formapag,idmatricula, valordesconto, valorinteiro, status, diavencimento
           });
    
            if(response.data.id){
              this.setState({ success: "Fatura Adicionada!" , error:null,
             });

             this.setState({ open: false,error:"" });
             window.location.replace("/admin/faturas/"+idmatricula);

            }else{
              this.setState({ success: null , error:response.data.error,
             });
            }
    
          }
      }
    

      
      


render() {

    const { open } = this.state;


return (
    <React.Fragment>

<div class="sizemodal ">
        <Modal class="col-xl"  open={open} onClose={this.onCloseModal} center>
       <div class="row text-center">
         
          <div class="col-lg-10">
          <h5>Criar Fatura ID #{this.state.idfatura} a gerar</h5>
          <div class="w-100"></div>
          </div>        
        </div>
          <div class="row">
          <div class="col-lg">
          <div class="w-100"></div>

          <form action="#" method="POST" onSubmit={this.addfatura}>


            <div class="row">

              <div class="col">
                <div class="form-group">
                  <label for="exampleInputEmail1">ID Fatura</label>
                  <input type="text" defaultValue="a gerar" readOnly class="form-control" onChange={e => this.setState({ idfatura: e.target.value })} id="exampleInputEmail1" aria-describedby="emailHelp" />
                </div>
              </div>

              <div class="col">
                <div class="form-group">
                    <label for="exampleInputEmail1">Matricula</label>
                    <input type="text" defaultValue={this.state.idmatricula} readOnly class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                </div>
              </div>
            </div>
  
  
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Valor Inteiro</label>
                <input type="text" defaultValue={this.state.valorinteiro} class="form-control" onChange={e => this.setState({ valorinteiro: e.target.value })} id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Valor Desconto</label>
                <input type="text" class="form-control" defaultValue={this.state.valordesconto} onChange={e => this.setState({ valordesconto: e.target.value })} id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </div>

           


          </div>

         

  

          <div class='row'>
            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Valor Pago</label>
                <input type="text" readOnly defaultValue={this.state.valorpago}  class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Dia Vencimento</label>
                <input type="date" onChange={e => this.setState({ diavencimento: e.target.value })} defaultValue={this.state.diavencimento} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                
              </div>
            </div>
          </div>



          <div class="form-group">
                <label for="exampleFormControlSelect1">Forma de Pagamento</label>
                <select class="form-control" id="exampleFormControlSelect1" onChange={e => this.setState({ formapag: e.target.value })}>
                <option value="0" selected={this.state.formapag==0}>Boleto</option>
                <option value="1" selected={this.state.formapag==1}>Cartão de Crédito</option>
                <option value="2" selected={this.state.formapag==2}>Cartão de Debito</option>
                <option value="3" selected={this.state.formapag==3}>Cheque</option>
                <option value="4" selected={this.state.formapag==4}>Especie</option>
                <option value="5" selected={this.state.formapag==5}>Outros</option>
                </select>
          </div>



          <div class="form-group">
            <label for="exampleFormControlSelect1">Status</label>
            <select class="form-control" id="exampleFormControlSelect1" onChange={e => this.setState({ status: e.target.value })}>
            <option value="0" >Cancelada</option>
            <option value="1" selected={true}>Não Paga</option>
            <option value="2" s>Paga</option>
            <option value="3" >Reembolsado</option>

            </select>
          </div>


          
  
  <button type="submit" class="btn btn-primary">Criar Fatura</button>
</form>
             
<center class="text-danger">{this.state.error}</center>
<center class="text-success">{this.state.success}</center>




          </div>

        </div>
       







         

        </Modal>
   
        </div>
    </React.Fragment>
)



}

}

export default withRouter(Map);


// WEBPACK FOOTER //
// ./src/pages/Admin/modulofinanceiro/modaladdfatura.js